import { Box, DialogContent, Typography } from '@mui/material';
import AddAccountProgressBar from '../shared/AddAccountProgressBar';
import ModalFooter from '../shared/ModalFooter';
import ModalSectionTitle from '../shared/ModalSectionTitle';
import { StepsForManual } from '../useAddAccountNavigation';
import { ClassificationItem } from '../categories.utility';
import { RealEstateDetailsFormState } from './useRealEstateDetailsForm';
import { Classification } from '@/store/classificationsApi';
import RealEstateDetailsForm from './RealEstateDetailsForm';

interface ManualAddRealEstateDetailsProps {
  handleOnCancel: () => void;
  footerLabels: any;
  updateModalStep: (step: StepsForManual) => void;
  selectedClassification: ClassificationItem;
  realEstateDetailsForm: RealEstateDetailsFormState;
  updateRealEstateDetailForm: (state: RealEstateDetailsFormState) => void;
  resetRealEstateDetailsForm: () => void;
  classifications: Classification[];
}

const ManualAddRealEstateDetails = ({
  handleOnCancel,
  footerLabels,
  updateModalStep,
  selectedClassification,
  realEstateDetailsForm,
  updateRealEstateDetailForm,
  resetRealEstateDetailsForm,
  classifications,
}: ManualAddRealEstateDetailsProps) => {
  return (
    <>
      <DialogContent>
        <Box sx={{ marginBottom: 4 }}>
          <AddAccountProgressBar
            activeStep={StepsForManual.MANUAL_ACCOUNT_DETAILS}
          />
          <ModalSectionTitle>Add Account Details</ModalSectionTitle>
          <Typography sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
            {selectedClassification.Name}
          </Typography>
        </Box>

        <RealEstateDetailsForm
          initialValues={realEstateDetailsForm.values}
          onFormChange={updateRealEstateDetailForm}
          selectedClassification={selectedClassification!}
          classifications={classifications}
        />
      </DialogContent>

      <ModalFooter
        onCancel={handleOnCancel}
        onBack={() => {
          resetRealEstateDetailsForm();
          updateModalStep(StepsForManual.MANUAL_ACCOUNT_TYPE);
        }}
        label={{ ...footerLabels, primaryCta: footerLabels.continue }}
        onPrimaryAction={() =>
          updateModalStep(StepsForManual.MANUAL_PORTFOLIO_DIVERSIFICATION)
        }
        isPrimaryActionDisabled={!realEstateDetailsForm?.isValid}
      />
    </>
  );
};

export default ManualAddRealEstateDetails;
